
























import { CampaignStats } from "@/types/campaign.types";
import { PropType } from "@vue/composition-api";

// @ts-ignore
import RadialProgressBar from "vue-radial-progress";

export default {
    components: {
        RadialProgressBar,
    },
    props: {
        header: {
            type: String,
            required: true,
        },
        campaignStats: {
            type: Object as PropType<CampaignStats>,
            required: true,
        },
    },
};
